export default [
  {
    path: '/warehouse/pickingList',
    name: 'picking-list',
    component: () => import('@/views/warehouse/pickingList'),
  },
  {
    path: '/warehouse/tallysSheet',
    name: 'tallys-sheet',
    component: () => import('@/views/warehouse/tallysSheet'),
  },
]